import {useEffect} from 'react'
import {Trans, useTranslation} from 'react-i18next'
import classNames from 'classnames'

import {ReactComponent as Building} from '../../assets/icons/building.svg'
import {ReactComponent as DiagramUp} from '../../assets/icons/diagram-up.svg'
import {ReactComponent as Link} from '../../assets/icons/link.svg'
import BannerContainer from '../../containers/BannerContainer'
import BannerSection from '../../containers/BannerSection'
import Card from '../Card/Card'

import ActionCard from './components/ActionCard/ActionCard'

import styles from './ActionList.module.scss'

export interface actionModel {
  actionKey: string
  descriptionKey: string
  icon: React.ReactElement
}

const actions = [
  {
    actionKey: 'action.inflation',
    descriptionKey: 'action.inflationDescription',
    icon: <Building />,
  },
  {
    actionKey: 'action.passiveIncome',
    descriptionKey: 'action.passiveIncomeDescription',
    icon: <DiagramUp />,
  },
  {
    actionKey: 'action.web3',
    descriptionKey: 'action.web3Description',
    icon: <Link />,
  },
]

interface IActionList {
  design?: 'first' | 'second'
}

const ActionList = ({design = 'first'}: IActionList) => {
  const {t} = useTranslation()
  useEffect(() => {}, [t])
  return (
    <BannerSection className={classNames(styles.section, styles[design])}>
      <BannerContainer className={classNames(styles.container, styles[design])} layout="column">
        <div className={classNames(styles.header, styles[design])}>
          <span className={classNames(styles.title, styles[design])}>
            {(design === 'first' && t('actionList.defaultTitle')) || (
              <Trans i18nKey="actionList.title">
                A simple, safe and <br />
                accessible investment
              </Trans>
            )}
          </span>
        </div>
        {design === 'first' && (
          <div className={styles.actionRow}>
            {actions?.map((action: actionModel) => (
              <Card key={action.actionKey} className={styles.actionCard} withShadow>
                <ActionCard actionData={action} />
              </Card>
            ))}
          </div>
        )}
      </BannerContainer>
    </BannerSection>
  )
}

export default ActionList
